import { render } from "./statusSwitch.vue?vue&type=template&id=0ae0c2f0&scoped=true"
import script from "./statusSwitch.vue?vue&type=script&lang=js"
export * from "./statusSwitch.vue?vue&type=script&lang=js"

import "./statusSwitch.vue?vue&type=style&index=0&id=0ae0c2f0&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae0c2f0"]])

export default __exports__